module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    key: "input",
    staticClass: "donation-box"
  }, [_c('div', {
    staticClass: "highlighted",
    domProps: {
      "innerHTML": _vm._s(this.$parent.locale.text_donation_description_highlight)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "src": "assets/img/supporting-families.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticStyle: {
      "font-size": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(this.$parent.locale.text_donation_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.kingscamps.org/wp-content/uploads/2024/12/FR-Fundraising-Badge-HR.png",
      "width": "40%"
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "donation-footer",
    domProps: {
      "innerHTML": _vm._s(this.$parent.locale.text_donation_footer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "donation-fields input"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.predefinedOptions), function(option) {
    return _c('div', {
      key: option,
      staticClass: "col"
    }, [_c('label', {
      staticClass: "col"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedOption),
        expression: "selectedOption"
      }],
      attrs: {
        "type": "radio",
        "name": "donation"
      },
      domProps: {
        "value": ("" + option),
        "checked": _vm._q(_vm.selectedOption, ("" + option))
      },
      on: {
        "change": _vm.handleDonationSelection,
        "__c": function($event) {
          _vm.selectedOption = "" + option
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("£" + _vm._s(option))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('label', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "name": "donation",
      "value": "roundToNext5"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "roundToNext5")
    },
    on: {
      "change": _vm.handleDonationSelection,
      "__c": function($event) {
        _vm.selectedOption = "roundToNext5"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Round to next £5 ( £" + _vm._s(_vm.formatAmount(_vm.getDonationAmount(5, true))) + " )")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('label', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "name": "donation"
    },
    domProps: {
      "value": 28,
      "checked": _vm._q(_vm.selectedOption, 28)
    },
    on: {
      "change": _vm.handleDonationSelection,
      "__c": function($event) {
        _vm.selectedOption = 28
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("£28 - Help subsidise a full day of camp for a child")])])]), _vm._v(" "), _c('label', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "name": "donation",
      "value": "custom"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "custom")
    },
    on: {
      "change": _vm.handleDonationSelection,
      "__c": function($event) {
        _vm.selectedOption = "custom"
      }
    }
  }), _vm._v("\n                    Custom Amount\n                ")]), _vm._v(" "), (_vm.selectedOption === 'custom') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation),
      expression: "donation"
    }],
    staticClass: "col-2",
    attrs: {
      "type": "text",
      "id": "donationInput",
      "placeholder": this.$parent.locale.text_donation_placeholder,
      "name": "donation"
    },
    domProps: {
      "value": (_vm.donation)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.apply($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.donation = $event.target.value
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('h4', [_vm._v("Selected Donation: £" + _vm._s(_vm.formatAmount(_vm.donation)))]), _vm._v(" "), (_vm.donation) ? _c('div', {
    staticClass: "gift-aid-box"
  }, [_c('h3', [_vm._v("Gift Aid Declaration")]), _vm._v(" "), _c('p', [_vm._v("\n                        By Gift Aiding your donation Kings Camps are able to claim an additional 25p per £1 donated, at no additional cost to you. \n                    ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giftAid),
      expression: "giftAid"
    }],
    attrs: {
      "type": "radio",
      "name": "giftAid",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.giftAid, "1")
    },
    on: {
      "__c": function($event) {
        _vm.giftAid = "1"
      }
    }
  }), _vm._v("\n                        Yes - Please claim gift aid – I confirm my name and address details are correct\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giftAid),
      expression: "giftAid"
    }],
    attrs: {
      "type": "radio",
      "name": "giftAid",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.giftAid, "0")
    },
    on: {
      "__c": function($event) {
        _vm.giftAid = "0"
      }
    }
  }), _vm._v("\n                        No – I do not wish for you to claim gift aid\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "gift-aid-box-footer"
  }, [_vm._v("\n                        By clicking Yes I agree that I want to Gift Aid my donation to Kings Camps, part of Kings Active Foundation (registered charity1105460/ SCO43119). I am a UK taxpayer and understand that if I pay less Income Tax and/or Capital Gains Tax in the current tax year than the amount of Gift Aid claimed on all my donations it is my responsibility to pay any difference. Please email membership@kingscamps.org to correct any contact details. \n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-6"
  }, [_c('input', {
    staticClass: "cta-button dark-blue",
    attrs: {
      "type": "submit",
      "id": "donationApply"
    },
    domProps: {
      "value": this.$parent.locale.button_donation_submit
    },
    on: {
      "click": _vm.apply
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-6"
  }, [_c('input', {
    staticClass: "cta-button red",
    attrs: {
      "type": "submit",
      "id": "donationApply"
    },
    domProps: {
      "value": this.$parent.locale.button_no_donation
    },
    on: {
      "click": _vm.applyNoDonation
    }
  })])])]), _vm._v(" "), (_vm.box.show) ? _c('div', {
    key: "alert",
    staticClass: "box-layout-inner alert"
  }, [_c('div', {
    staticClass: "full-width",
    class: _vm.box.colour
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.box.message)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.giftAidBox.show) ? _c('div', {
    key: "alert",
    staticClass: "box-layout-inner alert"
  }, [_c('div', {
    staticClass: "full-width",
    class: _vm.giftAidBox.colour
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.giftAidBox.message)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c533727"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Basket/BasketDonation.vue
// module id = 169
// module chunks = 0